import { render, staticRenderFns } from "./EditDenomination.vue?vue&type=template&id=280345fe&scoped=true&"
import script from "./EditDenomination.vue?vue&type=script&lang=js&"
export * from "./EditDenomination.vue?vue&type=script&lang=js&"
import style0 from "./EditDenomination.vue?vue&type=style&index=0&id=280345fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280345fe",
  null
  
)

export default component.exports